import React, { useEffect, useState } from "react";
import Axios from "../../../_services/caller.service";
import styles from "./HearingLicence.module.scss";
import { FiCopy } from "react-icons/fi";
import { toast } from "react-toastify";
import Modal from "../../UiComponents/modals/Modal";
import useModal from "../../../hooks/useModal";
import { IoMdAddCircleOutline } from "react-icons/io";
import Button from "../../UiComponents/Button";
import InputForms from "../../UiComponents/forms/InputForms";
import Select from "react-select";
import { v4 as uuidv4 } from "uuid"; // Import uuid library for generating GUIDs
import { PermissionGate } from "../../superAdmin/managePermissions/PermissionGate";
import { useTranslation } from "react-i18next";

// Region codes for major countries
const regionOptions = [
  { value: "FR", label: "France" },
  { value: "DE", label: "Germany" },
  { value: "ES", label: "Spain" },
  { value: "IT", label: "Italy" },
  { value: "US", label: "United States" },
  { value: "CA", label: "Canada" },
  { value: "UK", label: "United Kingdom" },
  { value: "JP", label: "Japan" },
  { value: "CN", label: "China" },
  { value: "IN", label: "India" },
];

const HearingLicence = () => {
  const { t } = useTranslation();
  const [editRowId, setEditRowId] = useState(null);
  const [formData, setFormData] = useState({});
  const [tableData, setTableData] = useState([]);
  const [newDataList, setNewDataList] = useState([]);
  const [numberOfLines, setNumberOfLines] = useState(1);
  const [users, setUsers] = useState([]);
  const [cabines, setCabines] = useState([]);
  const [selectedUserId, setSelectedUserId] = useState(null);
  const [allCabines, setAllCabines] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [maj, setMaj] = useState(false);
  const [selectedRegion, setSelectedRegion] = useState(regionOptions[0]); // Default to first option

  const { isShowing, toggle } = useModal();
  const columnOrder = [
    "ID",
    "CompteHS",
    "cabids",
    "RegionCode",
    "LicenceKey",
    "Notes",
  ];
  const handleRegionChange = (selectedOption) => {
    setSelectedRegion(selectedOption); // Update the selected region
  };

  // GENERATE LICENCE KEY
  const generateLicenceKey = (regionCode) => {
    const prefix = `HS-${regionCode}`; // Inclut le code de la région dans le préfixe
    const randomSegment1 = Math.random().toString(36).substring(2, 8).toUpperCase();
    const randomSegment2 = Math.random().toString(36).substring(2, 8).toUpperCase();
    const randomSegment3 = Math.random().toString(36).substring(2, 8).toUpperCase();
    return `${prefix}-${randomSegment1}-${randomSegment2}-${randomSegment3}`;
  };
  
  // Déclaration de la fonction getCabineNamesFromIds avant son utilisation
  const getCabineNamesFromIds = (cabids) => {
    if (!cabids) return "";
    const ids = cabids.split(",").map((id) => parseInt(id.trim()));
    const cabineNames = ids.map((id) => {
      const cabine = allCabines.find((cab) => cab.id === id);
      return cabine ? cabine.cabname : "";
    });
    return cabineNames.filter((name) => name !== "").join(", ");
  };

  //FONCTION DE RECHERCHE ET DE TRI DES DONNEES
  const sortedData = tableData.sort((a, b) => a.ID - b.ID);

  const filteredData = sortedData.filter((row) => {
    const cabineNamesString = getCabineNamesFromIds(row.cabids);
    return (
      (row.CompteHS || "").toLowerCase().includes(searchTerm.toLowerCase()) ||
      cabineNamesString.toLowerCase().includes(searchTerm.toLowerCase())
    );
  });

  // GET ALL DATA YOU NEED
  useEffect(() => {
    Axios.get("/getAllLicenceHearingspace")
      .then((res) => {
        console.log("Licences Data:", res.data.data);
        setTableData(res.data.data);
      })
      .catch((err) => console.error("Error fetching licences:", err));

    Axios.get("/getAllUserForSuperAdmin")
      .then((res) => {
        console.log("Users Data:", res.data.data);
        setUsers(res.data.data);
      })
      .catch((err) => console.error("Error fetching users:", err));

    Axios.get("/allCabines")
      .then((res) => {
        console.log("Cabines Data:", res.data.data);
        setAllCabines(res.data.data);
      })
      .catch((err) => console.error("Error fetching cabines:", err));
  }, [maj]);

  useEffect(() => {
    if (selectedUserId) {
      Axios.get(`/getCabinesIdByCenterAndCabname/${selectedUserId}`)
        .then((response) => {
          if (response.data && response.data.data) {
            const usedCabines = getUsedCabines();
            const availableCabines = response.data.data.filter(
              (cab) => !usedCabines.has(cab.id)
            );
            setCabines(availableCabines);
          } else {
            console.error("Erreur : Les cabines ne sont pas disponibles.");
          }
        })
        .catch((error) => {
          console.error("Erreur lors de la récupération des cabines :", error);
        });
    }
  }, [selectedUserId, tableData,maj]);

  //fonction pour extraire l'ID utilisateur de CompteHS

  // EDIT ROW
  const handleEdit = (rowId, rowData) => {
    setMaj(!maj); // permet que ca redonne les cabines disponibles
    setEditRowId(rowId);
    const currentRowData = tableData.find((row) => row.ID === rowData.ID);
    if (!currentRowData) {
      console.error("Erreur : Données de la ligne introuvables", rowData.ID);
      return;
    }

    setFormData({
      ...currentRowData,
      cabids: currentRowData.cabids
        ? currentRowData.cabids
            .split(",")
            .map((cabId) => parseInt(cabId.trim()))
        : [],
    });

    const userId = currentRowData.user_id || null;
    setSelectedUserId(userId);
    if (!userId) setCabines([]);
  };

  const getUsedCabines = () => {
    const usedCabines = new Set();
    tableData.forEach((row) => {
      if (row.ID !== formData.ID && row.cabids) {
        row.cabids.split(",").forEach((cabId) => {
          usedCabines.add(parseInt(cabId.trim()));
        });
      }
    });
    console.log(usedCabines);

    return usedCabines;
  };

  const handleCompteHsChange = (selectedOption) => {
    const userId = selectedOption ? selectedOption.value : null;

    setFormData({
      ...formData,
      user_id: userId || null,
      cabids: !userId ? [] : formData.cabids,
    });

    if (!userId) {
      setCabines([]);
    }

    setSelectedUserId(userId);
  };

  const handleCabineChange = (selectedOptions, key) => {
    // Map the selected options to their values and join them into a comma-separated string
    const selectedCabines = selectedOptions
      .map((option) => option.value)
      .join(",");
    setFormData({ ...formData, [key]: selectedCabines });
  };

  const handleInputChange = (e, key) => {
    setFormData({ ...formData, [key]: e.target.value });
  };

  // SAVE EDITED ROW
  const handleSave = () => {
    // Convert the cabids array to a comma-separated string if it exists
    const data = {
      ...formData,
      cabids: Array.isArray(formData.cabids)
        ? formData.cabids.join(",")
        : formData.cabids,
    };

    const id = data.ID; // Row ID

    Axios.put(`/updateHearingspaceLicence/${id}`, data)
      .then((response) => {
        const updatedDataList = tableData.map((item) =>
          item.ID === id ? { ...item, ...data } : item
        );
        setTableData(updatedDataList);
        toast.success(t("license.modification_success"));
        setEditRowId(null);
        setMaj(!maj);
      })
      .catch((error) => {
        console.error("Erreur lors de la mise à jour", error);
        toast.error(t("license.update_error"));
      });
  };

  // COPY TO CLIPBOARD FUNCTION
  const copyToClipboard = (text) => {
    navigator.clipboard.writeText(text).then(
      () => {
        toast("Copied to clipboard!");
      },
      (err) => {
        console.error("Could not copy text: ", err);
      }
    );
  };

  // GENERATE NEW ROWS
  const submitLines = () => {
    if (!selectedRegion) {
      toast.error(t("license.select_region_required"));
      return;
    }
  
    const linesToCreate = Array.from({ length: numberOfLines }, () => ({
      CompteHS: "", 
      cabids: "",
      RegionCode: selectedRegion.value, 
      LicenceKey: generateLicenceKey(selectedRegion.value), // Passe le RegionCode
      Notes: "",
      user_id: null,
    }));
  
    Axios.post("/createMultipleHearingspaceLicences", { lines: linesToCreate })
      .then((response) => {
        console.log(response);
        
        const updatedDataList = [...tableData, ...response.data.newLines];
        setTableData(updatedDataList);
        toast.success(t("license.lines_created"));
        toggle();
      })
      .catch((error) => {
        console.error("Erreur lors de la création des lignes", error);
        toast.error(t("license.lines_creation_error"));
      });
  };
  

  return (
    <div className={styles.containerDiracLicence}>
      <h2>{t("license.hearing_title")}</h2>
      <div className={styles.containersearchAndButton}>
        <InputForms
          type="text"
          placeholder={t("license.search_placeholder")}
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
        />
        <PermissionGate actionKey={"HSLicence.addNewLicence"}>
        <IoMdAddCircleOutline
          className={styles.iconAddNewMics}
          onClick={() => toggle()}
        
        /></PermissionGate>
      </div>

      <table className={styles.table}>
        <thead>
          <tr>
            {columnOrder.map((colKey) => (
              <th key={colKey} className={styles.th}>
                {colKey}
              </th>
            ))}
            <th className={styles.th}>Actions</th>
          </tr>
        </thead>
        <tbody>
          {filteredData.map((row, index) => (
            <tr key={index}>
              {columnOrder.map((colKey) => {
                const value = row[colKey];
                if (colKey === "LicenceKey") {
                  return (
                    <td key={colKey} className={styles.td}>
                      <div>
                        {value}
                        <FiCopy
                          onClick={() => copyToClipboard(value)}
                          className="has-tooltip"
                          aria-label={t("license.copy_key")}
                          style={{ cursor: "pointer", marginLeft: "10px" }}
                        />
                      </div>
                    </td>
                  );
                }
                if (colKey === "CompteHS" && editRowId === index) {
                  const selectOptions = [
                    { value: null, label: t("license.no_user") },
                    ...users.map((user) => ({
                      value: user.ID,
                      label: `${user.user_login} - ${user.ID}`,
                    })),
                  ];

                  return (
                    <td key={colKey} className={styles.td}>
                      <Select
                        options={selectOptions}
                        className={styles.selectUser}
                        value={selectOptions.find(
                          (option) => option.value === formData.user_id
                        )}
                        onChange={(selectedOption) =>
                          handleCompteHsChange(selectedOption)
                        }
                      />
                    </td>
                  );
                }

                if (colKey === "cabids") {
                  if (editRowId === index) {
                    const cabineOptions = cabines.map((cab) => ({
                      value: cab.id,
                      label: cab.cabname,
                    }));

                    return (
                      <td key={colKey} className={styles.td}>
                        <Select
                          isMulti
                          options={cabineOptions}
                          className={styles.selectCabine}
                          value={cabineOptions.filter((option) =>
                            formData.cabids.includes(option.value)
                          )}
                          onChange={(selectedOptions) =>
                            handleCabineChange(selectedOptions, "cabids")
                          }
                        />
                      </td>
                    );
                  } else {
                    return (
                      <td key={colKey}>{getCabineNamesFromIds(row.cabids)}</td>
                    );
                  }
                }

                if (colKey === "ID") {
                  return (
                    <td key={colKey} className={styles.td}>
                      {value}
                    </td>
                  );
                }

                return editRowId === index ? (
                  <td key={colKey} className={styles.td}>
                    <input
                      type="text"
                      className={styles.input}
                      value={formData[colKey]}
                      onChange={(e) => handleInputChange(e, colKey)}
                    />
                  </td>
                ) : (
                  <td key={colKey} className={styles.td}>
                    {value}
                  </td>
                );
              })}
              <td className={styles.td}>
                {editRowId === index ? (
                  <div className={styles.containerBtn}>
                    <button
                      className={styles.button}
                      onClick={() => handleSave(index)}
                    >
                      {t("common.save")}
                    </button>
                    <button
                      className={styles.buttonCancel}
                      onClick={() => {
                        setEditRowId(null);
                        setFormData({});
                      }}
                    >
                      {t("common.cancel")}
                    </button>
                  </div>
                ) : (
                      <PermissionGate actionKey={"HSLicence.updateLicence"}>
                  <button
                    className={styles.button}
                    onClick={() => handleEdit(index, row)}
                  >
                    {t("common.modify")}
                  </button></PermissionGate>
                )}
              </td>
            </tr>
          ))}
        </tbody>
      </table>

      <Modal isShowing={isShowing} hide={toggle}>
        <div className={styles.containerModal}>
          <input
            type="number"
            value={numberOfLines}
            onChange={(e) => setNumberOfLines(e.target.value)}
            placeholder={t("license.number_of_lines")}
         className={styles.inputSearch}
          />
          <Select
            id="regionSelect"
            options={regionOptions}
            value={selectedRegion}
            onChange={handleRegionChange}
            className={styles.selectRegion}
          />
          <Button
            onPress={submitLines}
            text={t("license.generate_lines")}
            styles={"btnValidation"}
          />
          {newDataList.map((line, index) => (
            <div key={index}>
              <span>{t("license.line_number", { number: index + 1 })}</span>
            </div>
          ))}
        </div>
      </Modal>
    </div>
  );
};

export default HearingLicence;
